import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { PopupMenuItem, PopupMenuList } from '$common/popup-menu'
import { RemoveCircleIcon } from '$common/icons/remove-circle'
// Localization
import { t } from '$i18n'

interface Prop {
  isOpen: boolean
  onRemove: () => unknown
}

export function RemoveMenu({ isOpen, onRemove }: Prop) {
  return (
    <PopupMenuList open={isOpen}>
      <PopupMenuItem
        text={t('menu.common.remove')}
        onClick={async () => {
          await onRemove()
          await closeCurrentModal()
        }}
      >
        <RemoveCircleIcon />
      </PopupMenuItem>
    </PopupMenuList>
  )
}
